export default __webpack_public_path__ + "static/media/logo2@2x.6ffe1f7a.png";